/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Kopfbereich im Hauptdialog
 *
 */
import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import icon_image from '../../../assets/images/login_image.png';
import * as appActions from "../../../store/actions/appActions";

import Logo from "../../partials/Logo";
import Welcome from "../../partials/Welcome";


class SplashScreen extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { windowWidth, windowHeight, orientation } = this.props.app;
        const height = windowHeight
        
        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================
        const renderBigImage = () => {

            const style = {
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundImage: "url(" + icon_image + ")",
                transition: 'all 0.25s'
            };   
    
            return (
                <div className="w-full h-full flex" style={style}></div>
            )        
        }

        const renderText = () => {
            return (
                <>
                    <Logo width={windowWidth * .75} version={true}/>
                    <div className="w-full">
                        <Welcome width={windowWidth * .75}/>
                    </div>
                </>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        const style = {
            height: height+'px',
            minHeight: height+'px',
            backgroundColor: 'rgb(145,28,33)'
        };

        if( orientation === 'landscape' ){
            return (
                <div className="absolute top-0 w-full h-full z-50 text-white flex " style={style}>
                    <div className="w-1/2 h-full flex" >
                            {renderBigImage()}
                    </div>
                    <div className="w-1/2 h-full flex flex-col" >
                        <div className="w-full h-full flex flex-col px-4 pb-4" >
                            {renderText()}
                        </div>
                    </div>                        
                </div>
            )    
        }

        return (
            <div className="absolute top-0 w-full z-50 text-white flex flex-col" style={style}>
                <div className="w-full flex" style={{height: '74%'}}>
                    {renderBigImage()}
                </div>
                <div className="w-full flex" style={{height: '26%'}}>
                    <div className="w-6/12 flex" ></div>
                    <div className="w-6/12 flex flex-col px-4 pb-4">
                        {renderText()}
                    </div>
                </div>
            </div>
        )

    }
}

function mapStateToProps(state){
    return {
        app: state.app
	}
}

function mapDispatchToProps(dispatch){
    return bindActionCreators( Object.assign({}, appActions ) , dispatch );
}

export default connect (mapStateToProps, mapDispatchToProps)( SplashScreen );
